import { render, staticRenderFns } from "./EditTodo.vue?vue&type=template&id=d82e73c8&scoped=true"
import script from "./EditTodo.vue?vue&type=script&lang=js"
export * from "./EditTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82e73c8",
  null
  
)

export default component.exports